<script>
import { fade } from 'svelte/transition'
import LogoAnim from '../videos/LogoAnim.svelte'

let showBalsam = false
setInterval( () => { showBalsam = !showBalsam }, 1000 * 2)
</script>

<style>
@keyframes bottle{
    from{ opacity:0; }
    to{ opacity:1; }
}

.container {
    width: 100%;
}

.hero-body .container {
}

.is-flexified {
    display: flex;
    justify-content: center;
    align-items: center;
}

h1 { font-size: 4rem; width: 50%;
    padding: 0 1rem;
    min-width: 300px;
}

span {
    display: none;
}

span.is-active {
    display: inline-block;
}

.under {
    display: none;
    width: 100%;
    height:80px;
}
.under span {
    width: 40%;
}

.logo{
    width:150px;
    top:0px;
    right:0px;
    cursor:pointer;
    position:absolute;
}
.logo .blackbar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 22%;
    background: radial-gradient(var(--bg-color) 55%, transparent 70%);
    z-index: -1;
}

.scroll-down {
    position: absolute;
    top: 50%;
    right: -75px;
    transform: translateY(-50%);
}

@media (max-width: 768px){
    h1 {
        font-size: 2.25rem;
        line-height: 1;
    }
    .is-flexified {
        flex-wrap: wrap;
    }
    .is-flexified .by-side {
        display: none;
    }

    .is-flexified .under {
        margin-top: 15px;
        margin-bottom: 15px;
        display: block;
    }

    span.is-active {
        display: inline;
    }

    .container img {
        /*max-width: 45%;*/
    }

    .container--logo {
        margin-top: -10px;
    }

    .logo{
        width:150px;
        top:0px;
        right:50%;
        transform: translateX(50%);
        cursor:pointer;
        position:absolute;
    }

    .hero-body{ margin-top:0px; padding-top:0px; }

    .scroll-down {
        display: none;
    }

}
a{ border:none; }
</style>

<section class="hero is-fullheight" style="position:relative;">
    <div class="scroll-down">
        <img src="./res/xo/scroll.svg" alt="">
    </div>
    <div class="hero-head">
        <div class="container container--logo is-clearfix has-text-centered" style="margin-top:-12px; position:relative; z-index:10;">
            <a href="http://www.rigablack.com/" target="_blank">
                <div class="logo">
                    <div class="blackbar"></div>
                    <img alt="Logo" src="./res/logo.svg" />
                </div>
            </a>
        </div>
    </div>
    <div class="hero-body">

        <div id="xo-logo" class="container container--blackflame">
            <div id="animWrap" class="is-clearfix has-text-centered is-flexified">
                <LogoAnim />
<!--                 <h1 class="by-side">Black</h1>


                <img alt="Riga Black Balsam" src="./res/bottle.png" /> -->

<!--
                <h1 class="by-side">
                    <span class:is-active={showBalsam} >Balsam</span>
                    <span class:is-active={!showBalsam} >Flame</span>
                </h1>
                <h1 class="under">
                    <div><span class="is-active">Black</span></div>
                    <span class:is-active={showBalsam} >Balsam</span><span class:is-active={!showBalsam} >Flame</span>
                </h1> -->
            </div>
            <!-- <div class="is-clearfix has-text-centered">
                <img alt="Scroll down" src="./res/down.svg" class="animated faa-vertical" />
            </div> -->
        </div>
    </div>
</section>
